module.exports = __webpack_public_path__ + "img/artwork-5.d32dd949.png";